export const FREE_LAYOUT_DEVICES = ["desktop", "tablet", "mobile"];

export const layoutDeviceForPreset = (preset) => {
  if (preset?.id === "tablet") return "tablet";
  return preset?.kind === "mobile" ? "mobile" : "desktop";
};

const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;

export const getFreeLayout = (node, device = "desktop") => {
  const current = node?.freeLayout?.[device];
  const legacy = node?.pos;
  const source = current || legacy || {};
  return {
    x: number(source.x),
    y: number(source.y),
    unit: source.unit === "%" ? "%" : "px",
    z: Math.round(number(source.z, number(node?.style?.zIndex))),
  };
};

export const withFreeLayout = (node, device, patch) => {
  const key = FREE_LAYOUT_DEVICES.includes(device) ? device : "desktop";
  const current = getFreeLayout(node, key);
  const next = {
    ...current,
    ...patch,
    x: Math.round(number(patch?.x, current.x)),
    y: Math.round(number(patch?.y, current.y)),
    z: Math.max(-1000, Math.min(1000, Math.round(number(patch?.z, current.z)))),
    unit: patch?.unit === "%" ? "%" : (patch?.unit === "px" ? "px" : current.unit),
  };
  return {
    ...node,
    // Keep desktop's historical `pos` mirror for old exports/readers while
    // tablet/mobile remain isolated in freeLayout.
    ...(key === "desktop" ? { pos: { x: next.x, y: next.y, unit: next.unit, z: next.z } } : {}),
    freeLayout: { ...(node?.freeLayout || {}), [key]: next },
  };
};

export const getPageLayoutMode = (page, device = "desktop") =>
  page?.layoutMode?.[device] === "free" ? "free" : "flow";

export const withPageLayoutMode = (page, device, mode) => ({
  ...page,
  layoutMode: { ...(page?.layoutMode || {}), [device]: mode === "free" ? "free" : "flow" },
});

export const nextLayer = (nodes, device, direction) => {
  const layers = (nodes || []).map((node) => getFreeLayout(node, device).z);
  if (!layers.length) return 0;
  return direction === "back" ? Math.min(...layers) - 1 : Math.max(...layers) + 1;
};

